module.exports = __webpack_public_path__ + "img/quest_icon_0072_special2.eb81b5ba.png";